export const USER_UPDATE_INFO = 'USER_UPDATE_INFO'
export const USER_UPDATE_EVALUATION = 'USER_UPDATE_EVALUATION'
export const SERVER_CONFIG_UPDATE = 'SERVER_CONFIG_UPDATE'
export const USER_EXAM_LIST = 'USER_EXAM_LIST'
